import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import VacancyForecastPage from "@/pages/admin/VacancyForecastPage";

export const Route = createFileRoute("/_admin/admin/vacancy-forecast")({
  head: () => pageHead("Admin · Vacancy Forecast", "AKIVA admin · vacancy forecast portal.", "/admin/vacancy-forecast", true),
  component: VacancyForecastPage,
});
